export function getView(is_hovered, state) {
  // return is_hovered ? 'CheckOut' : 'No'
  return is_hovered && state === 'UNSEATED' ? 'CheckOut' : 'No'
}
